
<template>
    
        <mars-view id="join" class="join-us" :data-area="fr + '_show'" data-serverid="16318" :data-exts="JSON.stringify({
        fr,
    })" :data-extswan="{
        fr,
    }" @click.native="joinUs"><slot>{{ text }}</slot></mars-view>
    
</template>

<script>
import { nav } from '../../static/utils/navigate';
import { inSightObservers } from '../../common/js/repeatExposureLog.js';
import log from '../../static/utils/ubcLog';
export default {
  props: {
    // 文案
    text: {
      'type': String,
      'default': '加入我们  |  律师合作'
    },
    fr: {
      'type': String,
      'default': ''
    }
  },
  mounted() {
    setTimeout(() => {
      inSightObservers('#join', '', {}, [], true, true, true);
    }, 1000);
  },
  methods: {
    /**
     * 加入我们
     */

    joinUs() {
      log.send({
        serverId: 16318,
        area: `${this.fr}_click`,
        action: 'click',
        fr: this.fr
      });
      nav({
        url: `/pages/settlement/marketingpage?fr=${this.fr}`
      });
      this.$emit('setHidePopup');
    }
  }
};
</script>

<style scoped>
.join-us {
  font-size: 0.14rem;
  color: #50525c;
  text-align: center;
}

</style>
